import { Accordion, CheckBox, Typography } from 'lighthouse';

import { SidebarTitle } from '../SidebarTitle';
import { CategoryFilterProps } from './models';

export const CategoryFilter = ({ categories }: CategoryFilterProps) => (
    <div className='overflow-hidden rounded-lg border border-gray-100 bg-white'>
        <Accordion
            typographyProps={{ variant: 'subtitle2', component: 'div' }}
            accordionShadow='elevation1'
            accordionSummery={<SidebarTitle title='دسته بندی محصولات' />}
            component='div'>
            <div>
                {categories.map((category) => (
                    <div key={category.id} className='group flex items-center gap-4 rounded-lg pl-2 transition hover:bg-blue-50/50'>
                        <CheckBox id={`cat-${category.id}`} />
                        <label htmlFor={`cat-${category.id}`} className='flex flex-1 cursor-pointer items-center justify-between text-sm'>
                            <Typography className='font-semibold text-blackMediumEmphasis transition group-hover:text-primary'>
                                {category.name}
                            </Typography>
                        </label>
                    </div>
                ))}
            </div>
        </Accordion>
    </div>
);
